module.exports = __webpack_public_path__ + "img/cape-verde.c2194f79.svg";